<template>
    <ui-crud title="Progress reports" subtitle="A list of progress reports for this package"
             :fetch="fetch" :pipe-with="pipeItems">

        <!-- Filters. -->
        <template #filters>
            <div class="relative">
                <ui-input class="mt-6" field="bg-gray-50 pr-10" name="search" v-model="search"></ui-input>
                <div class="absolute right-0 inset-y-0 h-full flex items-center justify-center p-3 text-gray-400">
                    <i class="fas fa-search"></i>
                </div>
            </div>
        </template>
        <!-- List item. -->
        <template #list-item="{ item, select, active }">
            <ui-crud-card
                :title="`${item.formatted_date}`"
                :subtitle="`${item.created_by}`"
                :metadata="`${toCurrency(item.complete.total)} • ${item.percentages.total}%`"
                :active="active"
                @click="select()"
            ></ui-crud-card>
        </template>

        <!-- Create form. -->
        <template #create="{ addItem, setEditMode, selectItem }">
            <progress-report-form :package-id="packageId" :store="$store" :add-item="addItem" :edit="setEditMode" :select-item="selectItem"></progress-report-form>
        </template>

        <template #edit="{ selectedItem, setEditMode }">
            <progress-report-form :package-id="packageId" :item="selectedItem" :store="$store" :edit="setEditMode"></progress-report-form>
        </template>

        <!-- Show page. -->
        <template #show="{ selectedItem, setEditMode, removeItem, addItem, selectItem }">
            <progress-report-show :item="selectedItem" :edit="setEditMode" :removeItem="removeItem" :select-item="selectItem"
                                  :package-id="packageId" :add-item="addItem" :store="$store"></progress-report-show>
        </template>
    </ui-crud>
</template>

<script>
import {progressReportStore} from "@stores";
import {toCurrency} from "../../utils";
import ProgressReportShowOld from "./ProgressReportShowOld.vue";
import ProgressReportFormOld from "./ProgressReportFormOld.vue";

export default {
    components: {ProgressReportForm: ProgressReportFormOld, ProgressReportShow: ProgressReportShowOld},
    props: {
        packageId: null,
        admin: Boolean,
    },
    computed: {
        $store() {
            return progressReportStore
        },
    },
    data() {
        return {
            search: '',
        }
    },
    methods: {
        toCurrency,
        async fetch() {
            await this.$store.init(this.packageId);
            return this.$store.state.items;
        },
        pipeItems(items) {
            const query = this.search.toLowerCase().split(/[^A-Za-z0-9.-]+/);
            if (query.length) {
                return items.filter((pr) => {
                    return query.every((token) => {
                        return pr.tokens.includes(token);
                    })
                });
            }
            return items;
        },
    },
}
</script>
